import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import * as global from '../global';

@Component({
  selector: 'app-merging',
  templateUrl: './merging.component.html',
  styleUrls: ['./merging.component.css']
})
export class MergingComponent implements OnInit {
  tabIndex: any;
  global=global;
  currentUser: any = null;
  Ids=[];
  devIds: Array<string> = ['62b04a1a0cf4669886601e76'];
  constructor(
    private _authService: AuthService,
  ) {
    this.currentUser = this._authService.currentUser;
    this.tabIndex =1;
   }

  ngOnInit(): void {
    this.Ids=[
      '621c9225a400cf68da5f9fb1',
      '622c4e4b568f7e34547c3eb0',
      '6380b08681b2c643c18eb569',
      '66aca56bd98259802d4f57b8',
      '62e8a89602192914a751f62e'
    ]
  }

  onTabClick(event) {
    this.tabIndex = event.index;

    return;
  }
  inSpecificIds() {
    if (global.ENVIRONMENT === "LOCAL" || global.ENVIRONMENT === "DEV") return this.devIds.includes(this.currentUser?._id?.toString());
    return this.Ids.includes(this.currentUser?._id?.toString());
  }
  // onTabClick(event) {
  //   this.tabIndex = event.index;

  //   return;
  // }
}
